module.exports = __webpack_public_path__ + "static/img/index-deco.56112494.png";